export const requestedGroupsCount = (state) => state.groupOverviewReducer.requestedGroupsCount;
export const invitedGroupsCount = (state) => state.groupOverviewReducer.invitedGroupsCount;
export const createGroupInfo = (state) => state.groupOverviewReducer.createGroupInfo;
export const uploadedImageUrl = (state) => state.createListReducer.uploadedImage.publicLink;
export const userId = (state) => state.sidebarReducer.userData.id;
export const userData = (state) => state.groupOverviewReducer.userData;
